import{m as n}from"./chunk-HBP5N4FR.js";n();var d=()=>typeof window!="undefined"&&typeof(window==null?void 0:window.location)!="undefined";export{d as a};
//# sourceMappingURL=chunk-OFOMMPSJ.js.map
